import { ContentContainer, ContentTitle } from 'components/Content';

export default function UnitConversion() {
  return (
    <ContentContainer>
      <ContentTitle>Unit Conversion</ContentTitle>
    </ContentContainer>
  );
}
